import { createStore, applyMiddleware, compose } from 'redux';
import createDebounce from 'redux-debounced';
import thunk from 'redux-thunk';
import { mergeWith } from 'lodash';
import rootReducer from '../reducers/rootReducer';
import getDefaultInitialState from './defaultInitialState';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const defaultInitialState = getDefaultInitialState();
let initialState = defaultInitialState;

try {
  if (localStorage.getItem('iuli')) {
    const storageState = JSON.parse(localStorage.getItem('iuli'));
    
    initialState = mergeWith({}, defaultInitialState, storageState, (objValue, srcValue) => {
      if (Array.isArray(srcValue)) {
        return srcValue;
      }
      return undefined;
    });
    
    if (initialState.payables?.filter?.filter_due_or_payment_date === null) {
      const freshDefaultState = getDefaultInitialState();
      initialState.payables.filter.filter_due_or_payment_date = [...freshDefaultState.payables.filter.filter_due_or_payment_date];
    }
    
    if (initialState.receivables?.filter?.filter_due_or_payment_date === null) {
      const freshDefaultState = getDefaultInitialState();
      initialState.receivables.filter.filter_due_or_payment_date = [...freshDefaultState.receivables.filter.filter_due_or_payment_date];
    }
    
    if (initialState.sales?.filter?.filterSaleCompetencyDate === null || 
        (Array.isArray(initialState.sales?.filter?.filterSaleCompetencyDate) && 
         initialState.sales.filter.filterSaleCompetencyDate.length === 0)) {
      const freshDefaultState = getDefaultInitialState();
      initialState.sales.filter.filterSaleCompetencyDate = [...freshDefaultState.sales.filter.filterSaleCompetencyDate];
    }
    
    initialState = {
      ...initialState,
      application: {
        ...defaultInitialState.application,
        loading: false,
      },
    };
  }
} catch (error) {
  console.log('getError', error);
}

const saver = (store) => (next) => (action) => {
  const stateToSave = store.getState();
  localStorage.setItem('iuli', JSON.stringify({ ...stateToSave }));
  return next(action);
};

const middlewares = [thunk, createDebounce(), saver];

const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(applyMiddleware(...middlewares))
);

export { store };
